module.exports = __webpack_public_path__ + "static/template-about-history-background-e6b7e04a206a9f18f47762a8ffc7ee1b.jpg";